import { normalizeSaisie } from '../normalizers/normalizeSaisie';
import PrintEnonce from '../helpers/PrintEnonce';
import { CONSIGNES } from '../consignes';
import { CONSIGNES_CAHIER } from '../helpers/saisiePolicy';
import { indexFigurePartagee } from '../helpers/groupQuestions';

/**
 * Renderer print d'un BLOC saisie groupé : un seul header "Exercice N",
 * une seule consigne, puis une liste numérotée 1./2./3. de sous-questions,
 * chacune avec sa propre ligne de saisie (si `saisieMode === 'sur_la_feuille'`).
 *
 * Mirror de PrintQcmGroup, adapté aux saisies libres.
 */
const PrintSaisieGroup = ({ exNum, items, saisieMode = 'sur_la_feuille', figurePartagee = null }) => {
    const surFeuille = saisieMode !== 'sur_le_cahier';
    return (
        <div className="ep-exo ep-saisie-group">
            <span className="ep-exo-num">{exNum}</span>
            <p className="ep-exo-consigne">{surFeuille ? CONSIGNES.saisie : CONSIGNES_CAHIER.saisie}</p>
            {figurePartagee?.element ? (
                <PrintEnonce className="ep-figgroup-figure" texte="" elements={[figurePartagee.element]} />
            ) : null}
            <ol className="ep-qcm-group-list">
                {items.map(({ payload, originalIndex }, idx) => {
                    const { question, correctAnswer, suffixe } = normalizeSaisie(payload, idx + 1);
                    const isShortAnswer = correctAnswer != null && correctAnswer.length <= 10;
                    const skipIdx = indexFigurePartagee(payload, figurePartagee?.cle);
                    return (
                        <li key={payload?.id ?? `sub-${originalIndex}`} className="ep-qcm-group-item">
                            <PrintEnonce
                                className="ep-qcm-group-question"
                                texte={question}
                                elements={payload?.elements_additionnels?.elements}
                                skipIndices={skipIdx >= 0 ? [skipIdx] : null}
                            />
                            {surFeuille && (
                                isShortAnswer ? (
                                    <div className="ep-answer-lines ep-answer-lines-short">
                                        <div className="ep-answer-line">
                                            {suffixe && <span className="ep-saisie-suffixe">{suffixe}</span>}
                                        </div>
                                    </div>
                                ) : (
                                    <div className="ep-answer-lines">
                                        <div className="ep-answer-line">
                                            {suffixe && <span className="ep-saisie-suffixe">{suffixe}</span>}
                                        </div>
                                        <div className="ep-answer-line" />
                                    </div>
                                )
                            )}
                        </li>
                    );
                })}
            </ol>
        </div>
    );
};

export default PrintSaisieGroup;
